export default __webpack_public_path__ + "83ed59e7556d758a6615446fa453eb11.woff2";